export const chapter6 = [

    //page 51
    'All day and into the night he ambled into the woods most deep,',
    'Eventually he collapsed and wrestled nightmares in his sleep,',
    'A new day dawned upon a broken and weary man,',
    'He struggled as what to do, he had no backup plan,',
    'In the roiling mess of his mind Sigg heard a quiet voice,',
    '“Come to me!”, He felt as if now he had little choice,',
    'Reluctantly Sigg stood and ambled north, it seemed about right,',
    'He tried not to think back too far every memory gave him fright,',
    '“Think fool!” He commanded himself to find a solution,',
    'Yet he felt like his life was merely an empty illusion,',
    'Throughout the day he battled to control his thought,',
    'But his memories would not stop their onslaught,',

    //page 52
    'His feet took him through to the woods north edges,',
    'He left the tall pines behind him amid green hedges,',
    'Sigg looked ahead and saw a barren mountain rising,',
    'He pushed himself on despite mentally agonizing, ',
    'Step after step he gradually ascended up the hill,',
    'He wasn‘t sure if why was because of his own will,',
    '“You don‘t need them”, a truth echoed inside his head,',
    'His sword and shield were vital, but he dropped them instead,',
    'He drew his knife and inflicted on himself a shallow cut,',
    'The hope that this was all a dream was slammed shut,',
    'The new pain in his hand felt far away,',
    'His own body seemed it was next to betray,',
    'The broad gloomy clouds above him obscured the sun from view,',
    'He had to make it up the mountain was all he could trust to be true,',
    'The plants around him became brown and dry-husk,',
    'He scrambled up all day long until that it was dusk,',
    '“Let it all go”, another command rattled between his ears,',
    'Sigg started to shed his precious armour fighting back the tears,',
    'Discarding each piece of steel should have made his burden less,',
    'But with each clattering to the ground it amplified Sigg‘s stress,',
    'Wearing mere cloth made him feel naked and truly cold,',
    'He wished he could start his life all again sorely tenfold,',

    //page 53
    'At last he stood atop the mountain, before him was a cave,',
    'With all he had been through he hoped it was to be his grave,',
    'After a few steps inside he saw light from torch of oil,',
    'Beneath his feet many footprints were cast in the soil,',
    'Somewhere inside him, something called out his name,',
    'Onwards and deeper he was like a moth to the flame,',
    'A long winding tunnel finished up with a wooden doorway,',
    'Someone had gone to a lot of effort to dig out stone and clay,',
    'Sigg paused with his hand on the handle fearing what could be inside,',
    'At this point anything was worth a chance from his mind he couldn‘t hide,',
    'It creaked open to reveal a large fully furnished cavern,',
    'Wooden plank floors, beds, stools and supplies like a tavern,',
    '“Ah Sigg you made it, come over here take a seat”,',
    'At the voice Sigg‘s heart nearly skipped a beat,',
    'He turned to see Eanom now wearing dark clothes and feathered hat,',
    'It was clear he was no town-guard and was experienced in combat,',
    'Eanom played skilfully tossing a curved blade in his hand,',
    'Sigg recognised a ring with the mark of Sutha on the band,',
    '“You killed the Governess?! Are you the schemer of this plot?”,',
    'Sigg thought about rushing him, but decided to wait for his shot,',
    '“Me? oh you complement me so, no Sigg, the master will soon return”,',
    '“The way you always meddle I can see why your subject to his spurn”,',

    //page 54
    'Just then a door at the rear opened and in stooped a behemoth of a man,',
    'His armour fought to contain his muscle and his skin was a dark tan,',
    'He wore a metal helm with bones and teeth protecting his mouth,',
    'Sigg was familiar with the craftmanship, it came from far down south,',
    '“I break twig man!” He roared revealing intellect was not his best strength,',
    'He wielded a mighty two-handed club which was intimidating in length,',
    '“Calm yourself Iron-jaw, you will wait for my word“ A new voice rung out,',
    'An old man walked in his voice soaked in authority he needed not to shout,',
    'Something about him was familiar to Sigg he knew that voice too well,',
    'After a moment he realized it was he who put him under the mind-spell,',
    '“Sorcerer!!” Sigg spat his emotions began to boil,',
    'Yet he knew nothing of the plans he needed to foil,',
    '“Like yourself I have a name, I am Rothkuul, Let‘s keep things civilized”,',
    '“I must admit when I learnt of your situation, I too was a bit surprized”,',
    'Sigg picked this one to be the one pulling strings behind the scenes,',
    'It was clear he was educated, arcanely-skilled and of vast means,',
    'He looked at Sigg with piercing eyes as he stroked his long grey beard,',
    'Being here alone, no weapons or armour was worse than he had feared,',
    '“I hear your name is Sigg, and you‘ve been quite the thorn in my side”,',
    '“But I‘m not angry, until recently you were out of range of me -your guide”,',


    //page 55
    'Rothkuul used an ornate mystical staff to help him walk forward,',
    '“Come follow me outside I‘ll tell you of my goal, listen to each word”,',
    'Both Eanom and Iron-jaw made complied and Sigg found himself going to,',
    'They exited the cave stood atop the mountain and soaked in the view,',
    'Night‘s curtain had been pulled only distant village lights could be spotted,',
    'It became obvious that from this vantage for years Rothkuul had plotted,',
    '“There you see Cragknoll, on the horizon Breglon and Sutha - just there”,',
    '“You probably expect I plan to destroy them all but it’s the opposite I  swear”,',
    '“You know as well as I what Cragknoll is hiding in the Tomb of the Lost King”,',
    '“It needs protection above all, but the elders knew nothing of war‘s sting”,',
    '“So yes I admit I provoked several Gobbo tribes to mount an attack”,',
    '“Because I knew without this Cragknoll would not change its track”,',
    'At this Sigg lost his cool and blurted “But hundreds of us were killed!”,',
    '“Silence! A price worth paying so more securely they would rebuild”,',
    '“Before you most see tiny villages, remote, lowly in common opinion”,',
    '“But you must know they‘re wrong it’s the cradle for a new dominion!”,',
    'The night mountain air swept them right through,',
    'Rothkuul went back inside and all followed cue,',


    //page 56
    '“So tell me Sigg, after all you‘ve seen, I‘m interested in your conclusion”,',
    '“Surely your efforts at being a ‚WarScholar‘ are valid despite the illusion”,',
    'Sigg felt like a month would be too little to wrest his mind back to form,',
    'He hated this place, everything in it the only positive was it was warm,',
    '“There are other ways without destruction you should have taken”,',
    '“I will not condone death of my kin, on this I will not be shaken!”,',
    'Rothkuul did not look impressed, Sigg could see a snarl start to build,',
    '“Fool! Can‘t you see without my actions more would‘ve been killed?”,',
    'He knocked his staff on the floor twice and spoke harsh tones,',
    'Before Sigg could react a shadow shot forth and froze his bones,',
    '“Your attitude is lacking but there is much in your mind I desire”,',
    'Sigg‘s mind began to unwind and felt like it was set on fire,',
    'Sigg fell and pumped air out through his respiratory system,',
    'This pain was on a whole new level he knew it would end him,',
    'All Sigg‘s combat insights, and village defence tactics were extracted,',
    'Rothkuul‘s battle knowledge grew and secrets were no longer redacted,',
    'A thin smile spread across his face as he drank Sigg‘s mind,',
    'But there was something there he did not expect to find,',
    'A parting gift from Elder Teelu -a trap waiting to be sprung,',
    'The magic backlash threw Rothkuul and collapsed his lung,',
    'The sorcerer toppled backward over a chair and fell into a heap,',
    'Sigg exhaled a scream narrowly avoiding falling into eternal sleep,',

    //page 57
    'His mind rattled senseless Sigg ran forward yelling an attack,',
    'But Iron-jaw caught and threw him into the wall with loud crack,',
    'A follow up punch sent Sigg breaking through a wooden beam,',
    'If he didn‘t have his air knocked out, he would‘ve used it to scream,',
    'Sigg fell down behind the wall into a deep crevasse,',
    'He had cuts all over like he‘d rolled in broken glass,',
    'Further down he tumbled between ledge and rock,',
    'Now in complete darkness his body went into shock,',
    'Wedged deep in the mountain near its ancient core,',
    'Sigg lost consciousness -it’s unknown how long for,',
    'His body began to shut down, it seemed this would be his tomb,',
    'For any lesser man this situation would spell certain doom,',




];